<template>
    <div :class="{Footer: true}">
        <div class="footer-main" :class="color_theme">
            <p class="line">
                <span>问题反馈{{ tpl }}邮箱：{{ mail }}（工作时间：周一至周五09:00-18:00）</span>
            </p>
            <p>
                <span>商业合作邮箱：wywshangye@baidu.com</span>
            </p>
            <p>
                <a :href="registerInfoUrl" target="_blank">
                    <span class="num"> © Baidu (京)-经营性-2017-0020京公网安备11000002000001号京ICP证030173号</span>
                </a>
            </p>
        </div>
    </div>
</template>

<script>
/**
 * @desc 法律 footer
 * @author baoleilei<baoleilei@baidu.com>
 * @desc 法律的登录页footer改为白色
 * @file Footer.vue
*/

import {mapState} from 'vuex';
export default {
    name: 'Footer',
    data() {
        return {
            baiduUrl: '//www.baidu.com',
            contactUsUrl: '//ziyuan.baidu.com/college/articleinfo?id=2114',
            instructionsUrl: '//xiongzhang.baidu.com/wiki/',
            collegeUrl: '//ziyuan.baidu.com/college#/type=2&cate=suggest-content',
            serviceAgreementUrl: '//xiongzhang.baidu.com/wiki/doc/chapter06',
            registerInfoUrl: '//www.beian.gov.cn/portal/registerSystemInfo?recordcode=11000002000001',
            disclaimerUrl: '//www.baidu.com/duty/',
            industry: 'law',
            tpl: '',
            mail: ''
        };
    },
    computed: {
        ...mapState({
            ind: state => state.Industry.ind
        }),
        color_theme() {
            return {
                gray: this.industry === 'law'
            };
        }
    },
    mounted() {
        if (this.industry === 'law') {
            this.mail = 'lvlin_help@baidu.com';
        }
    }
};

</script>

<style scoped lang="stylus">
.Footer
    margin 20px auto 0
    height 81px
    position relative
    .footer-main
        font-size 14px
        color #848B99
        line-height 26px
        opacity 0.65

        .line
            padding-top 16px

        p
            text-align center

        span,a
            margin-right 8px
            text-decoration none
            line-height 1.6

        .segmentation
            position relative
            margin-right 21px

            &:after
                absolute right -13px top 6px
                display block
                width 1px
                content ''
                height 8px
                background-color #dbdbdb

    .white
        color #fff
    
    .gray
        
        p
            a
                color #C5CCDB

</style>
